import React from 'react'

const TitleIcon: React.FC = (props) => (
	<svg {...props} focusable='false' viewBox='0 0 24 24' aria-hidden='true'>
		<path fill='currentColor' d='M5 4v3h5.5v12h3V7H19V4H5z' />
	</svg>
)

export default TitleIcon
